import { render, staticRenderFns } from "./zhuanguifeiyong.vue?vue&type=template&id=19acb3f6&scoped=true&"
import script from "./zhuanguifeiyong.vue?vue&type=script&lang=js&"
export * from "./zhuanguifeiyong.vue?vue&type=script&lang=js&"
import style0 from "./zhuanguifeiyong.vue?vue&type=style&index=0&id=19acb3f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19acb3f6",
  null
  
)

export default component.exports